import React, { Fragment } from "react"
import PropTypes from "prop-types"
import moment from "moment"
import { FormattedMessage } from "react-intl"

const BailkalTracking = ({ tracking }) => {
  const trackingInfoPath = (step, isLast) => {
    return (
      <div className="tracking-modal-row__icon-container">
        <div className={"icon"}>
          <div className={"icon-data"}>
            <div className={`point ${step?.achieved ? "active" : ""}`}></div>
          </div>
        </div>
        {isLast === false && <div className={`bottom-line ${step?.achieved ? "active" : ""}`}></div>}
      </div>
    )
  }

  return (
    <Fragment>
      <div className="tracking-modal-container">
        {tracking?.length === 0 && (
          <div>
            <FormattedMessage id={"bailkal.noTracking"} />
          </div>
        )}
        {tracking.map((globalStep, globalStepIndex) => {
          return (
            <div className={"tracking-modal-row"}>
              {trackingInfoPath(globalStep, globalStepIndex === tracking?.length - 1)}
              <div className={"tracking-modal-row__item"}>
                <div className="tracking-modal-row__title">
                  <div>
                    <span>{globalStep?.name}</span>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </Fragment>
  )
}

BailkalTracking.propTypes = {}

export default BailkalTracking
